import Role from "@/types/Role.interface"

interface State {
    roles: Role[]
}

const defaults = () => {
    return {
        roles: [],
    }
}
export default {
    state: defaults(),
    mutations: {
        rolesReset (state: State): void {
            Object.assign(state, defaults())
        },
        rolesSet (state: State, roles: Role[]): void {
            state.roles = roles
        }
    },
    actions: {
        rolesGet ({commit, getters}): Promise<boolean> {
            //  Assemble the API endpoint
            const url = `${getters.api}/roles`

            //  Send the request
            return window.axios.get(url).then(response => {
                //  Set our roles in the store
                commit('rolesSet', response.data)

                //  Return true since this was successful
                return true
            }).catch(() => null)
        }
    },
    getters: {
        //  Get all available roles
        roles (state: State): Role[] {
            return state.roles
        },
        //  Get roles that the current authenticated user is allowed to modify
        rolesAllowed(state, getters): Role[] {
            //  Fetch the current tenant
            const tenant = getters.tenant

            //  If the tenant does NOT exist, return error
            if (!tenant) throw 'No tenant is currently selected'

            //  Fetch the current authenticated user's tenant membership
            const membership = getters.user.memberships.find(x => x.tenant_id == tenant.id)

            //  If membership does NOT exist, return error
            if (!membership) throw 'No membership found for this user'

            //  Filter user roles 
            const allowed = getters.roles.filter(role => {
                return role.permission <= membership.role.permission
            })

            //  Return array of allowed roles
            return allowed
        }
    }
}